import { IonPage, IonInput, IonButton, IonSlides, IonGrid, IonItem, IonTabs, IonTabBar, IonTabButton, IonMenu, IonToolbar, IonTitle, IonContent, IonList, IonHeader, IonMenuToggle, IonLabel, IonSplitPane, IonRouterOutlet, IonFooter, IonModal, IonText, IonDatetime } from '@ionic/react';
import { IonSlide, IonRow, IonCol, IonIcon, IonButtons, IonMenuButton, IonImg } from '@ionic/react';
import { Link, Router, Redirect, Route, Switch } from "react-router-dom";
import React, {useState, useContext, useEffect} from 'react';

import { Modal_CreateIngredient } from './Modal_Create_Ingredient';
import { Modal_IngredientList } from './Modal_Ingredient_List';
import { Modal_CreateRecipe } from './Modal_Create_Recipe';
import { Modal_RecipeList } from './Modal_Recipe_List';

import {DateRange} from '../../../zInternal_Features/merchant/components/DateRange'


import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { PushNotifiPushNotificationSchema, PushNotifications, Token, ActionPerformed } from '@capacitor/push-notifications';
import { Toast } from "@capacitor/toast";


export function Modal_ManageRestaurant(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    //alert('In CheckIn_CheckOutSlides')
    //alert(authenticatedMerchent_context.acctID);
    //alert(authenticatedMerchent_context.accessRights);
    //alert(authenticatedMerchent_context.accessRights[0]);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(new Date(new Date().setDate(new Date().getDate())));
    let [endDate, setEndDate] = useState(new Date(new Date().setDate(new Date().getDate()+1)));

    let [startDate_display, setStartDate_display] = useState(false);
    let [endDate_display, setEndDate_display] = useState(false);

    let [numRoomsAvailable, setNumRoomsAvailable] = useState(null);
    let [numRoomsOccupied, setNumRoomsOccupied] = useState(null);
    let [numRoomsBooked, setNumRoomsBooked] = useState(null);
    let [numRoomsNeedCleaning, setNumRoomsNeedCleaning] = useState(null);

    let [searchGuestData, setSearchGuestData] = useState(null);

    let [createIngredientModal, setCreateIngredientModal] = useState(false);
    let [ingredientListModal, setIngredientListModal] = useState(false);
    let [createRecipeModal, setCreateRecipeModal] = useState(false);
    let [recipeListModal, setRecipeListModal] = useState(false);


    let [notifications, setnotifications] = useState([]);

    function searchGuestDataHandler(e) {
        
        setSearchGuestData(e.target.value);
    }

    function reloadDates(event)
    {
        // alert('In Reload')
        // alert(event)
        // alert(event[0])
        // alert(event[1])

        
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            //body: JSON.stringify({formData})
            body: JSON.stringify({
                Tracker: 74100,
                user: acctID,
                xStartDateRange: event[0],
                xEndDateRange: event[1],
                sessionID: sessionID,
            })

            
        }

    
        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            // alert(res);
            // alert(window.location.pathname)

            let rows = res.toString().split('~~~');
            let rowLength = rows.length;

                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setNumRoomsAvailable(cols[0]);
                    setNumRoomsOccupied(cols[1]);
                    setNumRoomsBooked(cols[2]);
                    setNumRoomsNeedCleaning(cols[3]);

                }

                    authenticatedMerchent_context.changeStartDateRange(event[0]);
                    authenticatedMerchent_context.changeEndDateRange(event[1]);
            
                
        })

    }

    useEffect(() => {
        
        reloadDates([startDate.toISOString().substr(0, 10), endDate.toISOString().substr(0, 10)]);

   }, []);

   //alert("in CheckInCheckOut");
   //alert(authenticatedMerchent_context.startDate);
   

    return (

        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonContent className='grid_content'>
                {notifications.length !== 0 &&
                <IonList>
                    {notifications.map((notif) =>
                        <IonItem key={notif.id}>
                            <IonLabel>
                                <IonText>
                                    <h3 className="notif-title">{notif.title}</h3>
                                </IonText>
                                <p>{notif.body}</p>
                            </IonLabel>
                        </IonItem>
                    )}
                    </IonList>}
                
                <IonGrid >
                    <IonRow>
                    {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonCol>
                            <h3>Create Ingredient</h3>
                            <IonButton onClick={() => setCreateIngredientModal(true)}> Add </IonButton>
                        </IonCol>}
                        <IonCol>
                            <h3>Ingredient List</h3>
                            <IonButton onClick={() => setIngredientListModal(true)}> View </IonButton>
                        </IonCol>
                    </IonRow>
                    <IonRow>
                    {authenticatedMerchent_context.accessRights[0] == 'admin' && <IonCol>
                            <h3>Create Recipe</h3>
                            <IonButton onClick={() => setCreateRecipeModal(true)}> Add </IonButton>
                        </IonCol>}
                        <IonCol>
                            <h3>Recipe List</h3>
                            <IonButton onClick={() => setRecipeListModal(true)}> View </IonButton>
                        </IonCol>
                    </IonRow>

                    {/*{authenticatedMerchent_context.accessRights[0] == 'admin' && 
                        <IonRow>
                            <IonCol>
                                    <input placeholder='Search Customer' onChange={ searchGuestDataHandler }></input>
                                    <IonButton onClick={() => setSearchGuestDataTracker(74117)}> Search Name</IonButton>
                            </IonCol>
                        </IonRow>}
                    {
                        searchGuestDataTracker != null &&
                            <GetGuestSearchMatch tracker={searchGuestDataTracker} searchGuestData={ searchGuestData }></GetGuestSearchMatch>
                    }*/}
                </IonGrid>


                {createIngredientModal == true && <Modal_CreateIngredient openModal={ createIngredientModal } closeModal={() => setCreateIngredientModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate} data={{
                    itemType: '', 
                                        }}></Modal_CreateIngredient>}

                {ingredientListModal == true && <Modal_IngredientList openModal={ ingredientListModal } closeModal={() => setIngredientListModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></Modal_IngredientList>}

                {createRecipeModal == true && <Modal_CreateRecipe openModal={ createRecipeModal } closeModal={() => setCreateRecipeModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate}></Modal_CreateRecipe>}

                {recipeListModal == true && <Modal_RecipeList openModal={ recipeListModal } closeModal={() => setRecipeListModal(false)} startDate={authenticatedMerchent_context.startDate} endDate={authenticatedMerchent_context.endDate} tracker={ 74104 }></Modal_RecipeList>}



            </IonContent>
            <IonFooter class='grid_footer'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonButton onClick={() => props.closeModal()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
    </React.Fragment>
    )
    //}   
}